import type { AdminGlobalSearchVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const searchGlobal = createApiThunk<AdminGlobalSearchVM, { query: string }>(
  "admin/searchGlobal",
  async ({ query }, { extra: { adminRepository } }) => {
    return adminRepository!.globalSearch(query);
  },
);
